function parseBoolean(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (value == null || value === "") return fallback;

  const normalized = String(value).trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) return true;
  if (["0", "false", "no", "off"].includes(normalized)) return false;
  return fallback;
}

const portalEnabled = parseBoolean(
  process.env.REACT_APP_CLIENT_PORTAL_ENABLED,
  false
);

// export const CLIENT_PORTAL_ENABLED = portalEnabled;
export const CLIENT_PORTAL_ENABLED = true;
export const CLIENT_PORTAL_CLAIM_ENABLED = true
export const CLIENT_PORTAL_AUTH_CHECKOUT_ENABLED = true;

export { parseBoolean };
